export const RmFilterInputRangeOptions = [
  { title: 'filter.equal', value: '=' },
  { title: 'filter.minor', value: '<' },
  { title: 'filter.major', value: '>' },
  { title: 'filter.minorOrEqual', value: '<=' },
  { title: 'filter.majorOrEqual', value: '>=' },
];
